import NewProjectSourceWizardConstants from './NewProjectSourceWizardConstants';

export function initializeWizard(form) {
  return { type: NewProjectSourceWizardConstants.INITIALIZE_PROJECT_NEW_SOURCE_WIZARD, form };
}

export function changeForm(form) {
  return { type: NewProjectSourceWizardConstants.CHANGE_PROJECT_NEW_SOURCE_FORM, form };
}
